import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ToolsGridView from "../../../ui/components/ToolsGridView";

import chatgpt from "../../../assets/openai-chatgpt.png";
import gemini from "../../../assets/gemini-ai.png";
import midjourney from "../../../assets/midjourney.png";
import elevenlabs from "../../../assets/elevenlabs.png";
import runway from "../../../assets/runway.png";
import suno from "../../../assets/suno.png";
import pika from "../../../assets/pika.png";
import claude from "../../../assets/claude.png";
import canva from "../../../assets/Canva.png";

const GENERATE_TOOLS = [
  { name: "Chat GPT", icon: chatgpt },
  { name: "Gemini", icon: gemini },
  { name: "Claude", icon: claude },
  {
    name: "Eleven Labs",
    icon: elevenlabs,
    url: "https://elevenlabs.io",
  },
  {
    name: "Runway",
    icon: runway,
    url: "https://runway.com/product",
  },
  {
    name: "Suno",
    icon: suno,
    url: "https://suno.com",
  },
  {
    name: "Pika",
    icon: pika,
    url: "https://pika.art",
  },
  {
    name: "Midjourney",
    icon: midjourney,
    url: "https://www.midjourney.com/home",
  },
  {
    name: "Canva",
    icon: canva,
    url: "https://www.canva.in",
  },
];

export default function GeneratePage() {
  const navigate = useNavigate();
  const [activeIframe, setActiveIframe] = useState(null);

  const handleToolClick = (tool) => {
    if (tool.name === "Chat GPT") {
      navigate("/generate/chatgpt");
    } else if (tool.name === "Gemini") {
      navigate("/generate/gemini");
    } else if (tool.name === "Claude") {
      navigate("/generate/claude");
    } else if (tool.url) {
      window.open(tool.url, "_blank");
    }
  };

  return (
    <ToolsGridView
      title="Let's make something."
      tools={GENERATE_TOOLS}
      onToolClick={handleToolClick}
      // activeIframe={activeIframe}
      // setActiveIframe={setActiveIframe}
    />
  );
}
